// extracted by mini-css-extract-plugin
export default {"Page":"CompanySettingPage_Page__ed2ID"};